const COLORS = {
  slate:
    'text-slate-500 bg-slate-50 border !border-slate-200 hover:border-slate-300 hover:text-slate-600',
  blue: 'text-blue-500 bg-blue-50 border !border-blue-200 hover:border-blue-300 hover:text-blue-600',
  yellow: 'bg-yellow-200 text-amber-800 border border-yellow-500'
};

export function RowMiscButton({ label, subtitle, icon, selected, color = 'slate' }) {
  const Icon = icon;
  const colorClasses = COLORS[color];
  const defaultClasses = `h-[24px] flex items-center justify-center relative !border !border-solid rounded-full ${colorClasses}`;

  const withLabelClasses = !!label ? 'text-[11px] px-2 !max-w-[120px] w-full truncate' : 'w-6 h-6';

  return (
    <span className={`${defaultClasses} ${withLabelClasses}`}>
      {icon && <Icon className="w-4 h-4" />}
      <span className="truncate">{label}</span>
    </span>
  );
}
